<div class="container-content">
  @for (f of field.fieldGroup; track f) {
    <formly-field [field]="f" fxFlex="50%"></formly-field>
  }
</div>